import React from "react";
import Banner from '../../components/banner/banner' ;
import { Container } from "react-bootstrap";
 
const Loading = () => {
    <Container style={{backgroundColor:"#E4F4F3"}} >
        <Banner/>
        <div className="d-flex justify-content-center align-items-center">
            <p className="h1"><b>Loading...</b></p>
        </div>
    </Container>
} ;

export default Loading ;